<!--
 * @Author: 卷柏 1350797548@qq.com
 * @Date: 2024-07-14 12:05:24
 * @LastEditors: 卷柏 1350797548@qq.com
 * @LastEditTime: 2024-07-17 11:12:21
 * @FilePath: \pc\coursearrange\src\dataBoard\dataBoard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>

    <div style="display: flex;">
      <div style="width:100px;">全部老师</div>
      <div class="progress-bar" style="width: 95%; margin-top: 4px;">
        <div class="bar" :style="{ 'background-color': getColor(0), width:'30%'  }"></div>
        <div class="bar" :style="{ 'background-color': getColor(1), width:'50%'  }"></div>
        <div class="bar" :style="{ 'background-color': getColor(2), width:'15%'  }"></div>
        <div class="bar" :style="{ 'background-color': getColor(3), width:'5%'  }"></div>
      </div>
    </div>


    <div style="display: flex; justify-content: center; margin-top: 20px;">
      <div style="display: flex;">
        <div :style="{ 'background-color': getColor(0), width:'15px', height: '15px', 'margin-top': '2px', 'margin-right': '3px'  }"></div>
        <div style="margin-right: 10px;">初级老师</div>
      </div>
      <div style="display: flex;">
        <div :style="{ 'background-color': getColor(1), width:'15px', height: '15px', 'margin-top': '2px', 'margin-right': '3px'  }"></div>
        <div style="margin-right: 10px;">中级老师</div>
      </div>
      <div style="display: flex;">
        <div :style="{ 'background-color': getColor(2), width:'15px', height: '15px', 'margin-top': '2px', 'margin-right': '3px'  }"></div>
        <div style="margin-right: 10px;">高级老师</div>
      </div>
      <div style="display: flex;">
        <div :style="{ 'background-color': getColor(3), width:'15px', height: '15px', 'margin-top': '2px', 'margin-right': '3px'  }"></div>
        <div style="margin-right: 10px;">特级老师</div>
      </div>
    </div>


    <div style="display: flex; padding-top: 30px;">
      <div style="width:49%;height: 500px;border-radius: 10px; border: 1px solid #c5c2c2;" >
        <div style="text-align: start; padding: 10px;">各职级老师数量柱状图：</div>
        <div style="display: flex;">
          <div style="padding: 10px;">日期：</div>
          <div>
            <el-date-picker @change="handlechange1" v-model="pickerTime" type="date" style="width: 100%;" value-format="yyyy-MM-dd" placeholder="请选择日期" clearable></el-date-picker>
          </div>
        </div>
        <div style="margin-top: 40px;">
          <div id="echarts1" style="height: 400px; width:100%;"></div>
        </div>
        <!-- <div class="box">
          <div></div> <div></div> <div></div> <div></div>
        </div> -->
      </div>

      <div style="width:49%;height: 500px;border-radius: 10px; margin-left: 10px; border: 1px solid #c5c2c2;" >
        <div style="text-align: start; padding: 10px;">当月老师职级占比：</div>
        <div style="display: flex;">
          <div style="padding: 10px;">日期：</div>
          <div>
            <el-date-picker @change="handlechange2" v-model="pickerTime1" type="date" style="width: 100%;" value-format="yyyy-MM-dd" placeholder="请选择日期" clearable></el-date-picker>
          </div>
        </div>
        <div style="margin-top: 40px;">
          <div id="echarts2" style="height: 400px; width:100%;"></div>
        </div>
        <!-- <div class="box">
          <div></div> <div></div> <div></div> <div></div>
        </div> -->
      </div>
    </div>

    <div style="display: flex; margin-top: 22px;">
      <div style="margin-top: 10px;">老师职级：</div>
      <div>
        <el-select @change="handleselectvalue" v-model="selectvalue" clearable filterable placeholder="请选择老师职级">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">  </el-option>
        </el-select>
      </div>
    </div>

    <el-table style="margin-top: 20px; margin-bottom: 6px;"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="300">
      <el-table-column prop="name" label="老师姓名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="a" label="三个月内连续周测成绩优异次数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="b" label="累计周测成绩优异次数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="c" label="六个月内规划课课节数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="d" label="三个月内学员首次规划课成功率" show-overflow-tooltip></el-table-column>
      <el-table-column prop="e" label="内推成功入职员工" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
          <template slot-scope="scope">
              <div style="display: flex;justify-content: space-around;">
                <el-button type="text" style="color:#00aaff;" @click="handleClickView(scope.row)">详情</el-button>
              </div>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-size="pageSize"
        layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>

    <el-dialog  :center="true" :close-on-click-modal="false" title="详情" :visible.sync="DialogShow"  @close="rejectDialogShowClr" width="70%">
      <div style="display: flex; width:100%;margin-bottom: 40px;">
        <div style="width:49%;">
            <div style="margin-bottom: 40px;">
              <span>老师姓名:</span>
              <span>张三</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>三个月内连续周测成绩优异次数：</span>
              <span>3次/</span>
              <span style="color:red;">3次</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>六个月内规划课课节数：</span>
              <span>200节/</span>
              <span style="color:red;">200节</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>是否达到非寒暑假月份的当月第一周稳定规划中（满 5 节课）学员达到 10 名，寒暑假月份的学员需满足转季后的第一周稳定规划中（满 5 节课）学员数达到 10 名：</span>
              <span>否/</span>
              <span style="color:red;">是</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>连续 10 个学员满 5 节规划课的续报率：</span>
              <span>80%/</span>
              <span style="color:red;">80%</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>内推成功入职员工：</span>
              <span>2人/</span>
              <span style="color:red;">2人</span>
            </div>
        </div>
        <div style="width:49%; margin-left: 10px;">
            <div style="margin-bottom: 40px;">
              <span>老师职级:</span>
              <span>初级老师</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>累计周测成绩优异次数:</span>
              <span>6次/</span>
              <span style="color:red;">6次</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>三个月内学员首次规划课成功率：</span>
              <span>80%/</span>
              <span style="color:red;">80%</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>任意连续 3 个月内的所有学员首次规划课成功率：</span>
              <span>80%/</span>
              <span style="color:red;">80%</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>6 个月内满 20 节课的规划中学员数量：</span>
              <span>5人/</span>
              <span style="color:red;">5人</span>
            </div>
            <div style="margin-bottom: 40px;">
              <span>下一晋升职级：</span>
              <span>中级老师</span>
            </div>
        </div>
      </div>
      <div style="color:red;">*注：红色字体为达到晋升职级条件，黑色为当前进度</div>
    </el-dialog>




  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from "axios";
import apiBaseUrl from "../../config/api";
export default {
  data() {
    return {

      DialogShow:false,

      pickerTime:'',
      pickerTime1:'',
      options:[
        { value: 1, label: '初级老师'},
        { value: 2, label: '中级老师'},
        { value: 3, label: '高级老师'},
        { value: 4, label: '特级老师'},
      ],
      selectvalue:'',

      dataList:[
        {
          name:'吴亦凡',
          a: 5,
          b: 10,
          c: 15,
          d: 80,
          e: 20,
        }
      ],
      pageSize: 10,
      pageNum: 1,
      total: 0,

    };
  },
  mounted() {
    this.handleGetEcharts()
    this.handleGetEcharts1()
  },

  methods: {

    handleselectvalue(e){
      console.log(e)
    },

    rejectDialogShowClr(){
      this.DialogShow = false
    },

    handleClickView(row){
      console.log(row)
      this.DialogShow = true
    },

    handleSizeChange(e){
      this.pageSize = e
    },

    handleCurrentChange(e){
      this.pageNum = e
    },

    getColor(index) {
      const colors = ['#40a9ff', '#90de96', '#c290de', '#f1b93c'];
      return colors[index];
    },

    handleGetEcharts(){
      let chartDom = document.getElementById('echarts1');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        show: true,
        tooltip: { trigger: 'axis'},
        xAxis: { type: 'category', data: ['初级老师', '中级老师', '高级老师', '特级老师'] },
        yAxis: { type: 'value' },
        series: [ { type: 'bar', data: [
          { value: 100, itemStyle: { color: this.getColor(0) } },
          { value: 200, itemStyle: { color: this.getColor(1) } },
          { value: 300, itemStyle: { color: this.getColor(2) } },
          { value: 400, itemStyle: { color: this.getColor(3) } },
        ]}],
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }

    },

    handleGetEcharts1(){
      let chartDom = document.getElementById('echarts2');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        show: true,
        tooltip: {  trigger: 'item'  },
        legend: {  orient: 'vertical', left: 'left',  },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [{ value: 1048, name: '初级老师', itemStyle: { color: this.getColor(0) } }, { value: 735, name: '中级老师', itemStyle: { color: this.getColor(1) } }, { value: 580, name: '高级老师', itemStyle: { color: this.getColor(2) } },  { value: 484, name: '特级老师', itemStyle: { color: this.getColor(3) } },  ],
            emphasis: {itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' } }
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }

    },


    handlechange1(e){
      console.log(e)
    },


    handlechange2(e){
      console.log(e)
    },



  }

}

</script>

<style scoped>
    .progress-bar {
      display: flex;
      height: 10px;
      border-radius: 10px;
    }
    .bar {
      height: 100%;
    }

    .box{
        width:100%;
        height: 400px;
        transform: translate(0%, -105%);
        overflow: hidden;
        background-color: transparent;
    }


    .box :nth-child(1) {
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
        animation: run1 2s linear infinite;
        background: linear-gradient(to right, #1beb1b, rgb(216, 229, 35), rgb(23, 172, 231));
    }

    .box :nth-child(2) {
        top: 0;
        right: 0;
        height: 100%;
        width: 2px;
        animation: run2 2s linear infinite;
        background: linear-gradient(to bottom,  #1beb1b, rgb(216, 229, 35), rgb(23, 172, 231));
    }

    .box :nth-child(3) {
        bottom: 0;
        left: 0;
        height: 2px;
        width: 100%;
        animation: run3 2s linear infinite;
        background: linear-gradient(to left, #1beb1b, rgb(216, 229, 35), rgb(23, 172, 231));
    }

    .box :nth-child(4) {
        top: 0;
        left: 0;
        height: 100%;
        width: 2px;
        animation: run4 2s linear infinite;
        background: linear-gradient(to top, #1beb1b, rgb(216, 229, 35), rgb(23, 172, 231));
    }


    @keyframes run1 {
        from {
            transform: translateX(-100%)
        }
        to {
            transform: translateX(100%)
        }
    }

    @keyframes run2 {
        from {
            transform: translateY(-100%)
        }
        to {
            transform: translateY(100%)
        }
    }

    @keyframes run3 {
        from {
            transform: translateX(100%)
        }
        to {
            transform: translateX(-100%)
        }
    }

    @keyframes run4 {
        from {
            transform: translateY(100%)
        }
        to {
            transform: translateX(100%)
        }
    }

</style>



// WEBPACK FOOTER //
// src/dataBoard/dataBoard.vue